import classnames from 'classnames';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCaptureState } from '../context';

const PauseIcon = ({ className, ...props }: { className?: string; [key: string]: unknown }) => {
  const { shortcut, mediaRecorder, pauseRecord, resumeRecord } = useCaptureState();
  const isRecording = useMemo(
    () => ['recording', 'paused'].includes(mediaRecorder?.state),
    [mediaRecorder?.state]
  );
  const isPaused = useMemo(() => mediaRecorder?.state === 'paused', [mediaRecorder?.state]);
  const isStopped = useMemo(() => !(isRecording || isPaused), [isPaused, isRecording]);

  const { t } = useTranslation('Vindoc');

  const handleClick = useCallback(() => {
    if (isPaused) {
      resumeRecord();
    } else {
      pauseRecord();
    }
  }, [isPaused, pauseRecord, resumeRecord]);

  return (
    <div
      className={classnames('pause-wrapper', className, {
        'opacity-0': isStopped,
      })}
      onClick={handleClick}
      title={isPaused ? t(`Resume (${shortcut.pause})`) : t(`Pause (${shortcut.pause})`)}
    >
      <button
        className={classnames(`btn-pause`, {
          'paused': isPaused,
          'recording': isRecording,
        })}
        {...props}
      />
    </div>
  );
};

export default PauseIcon;
